import { SET_DATE_FORMAT } from '../../actions/common/agentDateFormat';

const agentDateFormat = (state = 'LL', action) => {
  switch (action.type) {
    case SET_DATE_FORMAT:
      return action.payload;

    default:
      return state;
  }
};

export default agentDateFormat;
